export default __webpack_public_path__ + "static/media/bannerSmall4.62fcabd7.png";